<script lang="ts">
	import type { HTMLLiAttributes } from 'svelte/elements'

	import { cn } from '$lib/utils/shadcn'

	type $$Props = HTMLLiAttributes & {
		el?: HTMLLIElement
		itemprop: string
		itemscope: boolean
		itemtype: string
	}

	export let el: $$Props['el'] = undefined
	export let itemprop: string
	export let itemscope: boolean
	export let itemtype: string
	let className: $$Props['class'] = undefined
	export { className as class }
</script>

<li
	bind:this={el}
	class={cn('inline-flex items-center gap-1.5', className)}
	{itemprop}
	{itemscope}
	{itemtype}
>
	<slot />
</li>
